import React, { PropTypes as pt } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import FullWrapper, { Content } from './FullWrapper';
import {
    getCurrentLanguage, getCurrentLanguageId, getData, getIsFormSubmitting,
    getLanguagesOptions,
} from '../selectors';
import { Select } from 'incab/common';
import { MARATHONS_SHOW_REGISTRATION, register, selectLanguage } from '../actions';

import btnFB from '../img/btn-fb.png';
import btnVK from '../img/btn-vk.png';
import { createAction } from '../../utils/actions';
import Registration from './Registration';

class CmpRegistrationForm extends React.Component {
    static propTypes = {
        currentLanguage: pt.string.isRequired,
        currentLanguageId: pt.number.isRequired,
        languages: pt.arrayOf(pt.shape()),
        onLanguageChanged: pt.func.isRequired,
        data: pt.shape(),
        termsUrl: pt.string.isRequired,
        registration: pt.shape().isRequired,
        onClose: pt.func.isRequired,
        onRegister: pt.func.isRequired,
        isFormSubmitting: pt.bool,
    };

    handleLanguageChanged = (name, value) => this.props.onLanguageChanged(value);

    handleSubmit = e => {
        e.preventDefault();
        this.props.onRegister({ ...this.props.data, languageCode: this.props.currentLanguage });
    };

    render() {
        const {
            currentLanguage,
            currentLanguageId,
            languages,
            termsUrl,
            registration,
            onClose,
            isFormSubmitting,
        } = this.props;
        return (
            <FullWrapper>
                <RegistrationFormContent lang={currentLanguage} className="container">
                    <a className="btn-close" href="#" onClick={onClose}><i className="fa fa-close fa-2x" /></a>
                    <div className="row">
                        <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
                            <div className="card">
                                <div className="card-block">
                                    <form onSubmit={this.handleSubmit}>
                                        <Select
                                            id="reg-lang"
                                            options={languages}
                                            value={currentLanguage}
                                            name="lang"
                                            hasEmpty={false}
                                            horizontal={false}
                                            onChange={this.handleLanguageChanged}
                                        />
                                        <h4 className="card-title">Зарегистрируйтесь сейчас и начните обучение</h4>

                                        <div className="social">
                                            <a href={`${registration.facebook}?marathon=${currentLanguageId}`}><img
                                                src={btnFB} /></a>
                                            <a href={`${registration.vk}?marathon=${currentLanguageId}`}><img
                                                src={btnVK} /></a>
                                        </div>

                                        <div className="my-4 text-center or">
                                            <hr />
                                            <span>или</span>
                                            <hr />
                                        </div>

                                        <Registration />

                                        <button
                                            disabled={isFormSubmitting}
                                            type="submit"
                                            className="btn btn-primary btn-block mt-2"
                                        >
                                            Начать марафон бесплатно
                                        </button>

                                        <small className="d-block mt-4">
                                            Присоединяясь, я заявляю, что прочитал и принимаю <a
                                            href={termsUrl} target="_blank"
                                        >Правила и условия</a>.
                                        </small>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </RegistrationFormContent>
            </FullWrapper>
        );
    }
}

const RegistrationFormContent = styled(Content)`
    background: no-repeat center center #2f3e9d;
    background-size: cover;
    background-image: url(/static/img/bg/${props => (props.lang || 'en')}.jpg);
    transition: background-image 1s ease-in-out;
    
    .social {
        display: flex;
        flex-direction: row;
        justify-content: center;
        
        a {
            text-decoration: none !important;
            margin: 0 1em;

            img {
                width: 48px;
                height: 48px;
            }
        }
    }
    
    .card {
        box-shadow: 0 5px 20px rgba(0, 0, 0, .5);
    }
    
    .card-title {
        font-size: 100%;
        text-align: center;
    }
    
    .or {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        
        hr {
            width: 100%;
        }
        
        span {
            margin: 0 1em;
            line-height: 2rem;
            color: rgba(0, 0, 0, 0.5);
        }
    }
`;

export default connect(
    state => ({
        currentLanguage: getCurrentLanguage(state),
        currentLanguageId: getCurrentLanguageId(state),
        languages: getLanguagesOptions(state),
        data: getData(state),
        isFormSubmitting: getIsFormSubmitting(state),
    }),

    dispatch => ({
        onLanguageChanged: language => dispatch(selectLanguage(language)),
        onClose: () => dispatch(createAction(MARATHONS_SHOW_REGISTRATION, false)),
        onRegister: data => dispatch(register(data)),
    }),
)(CmpRegistrationForm);



// WEBPACK FOOTER //
// ./src/marathons/components/RegistrationForm.jsx